export const baseUrl = "https://admin.winscore.in/";


export const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
  }
};
